<template>
  <div class="fail-content">
    <div class="icon-wrapper">
      <slot name="icon">
      </slot>
    </div>
    
    <h2 class="main-title">{{ mainTitle }}</h2>
    
    <div class="hints">
         <p v-for="(hint, index) in hints" :key="index" class="hint-item"> {{ Object.prototype.toString.call(hint)=== '[object Object]'?`${hint.label}${hint.value ? '：' + hint.value : ''}` : hint }}</p>
    </div>
    
    <button class="confirm-btn" @click="handleConfirm">
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'FailContent',
  props: {
    mainTitle: {
      type: String,
      default: '车辆不在本次升级范围'
    },
    hints: {
      type: Array,
      default: () => [{
        label: '可持续关注官方OTA升级通知'
      }]
    },
    buttonText: {
      type: String,
      default: '确认'
    },
    confirmMethod: {
      type: Function,
      default: null
    }
  },
  methods: {
    handleConfirm() {
      if (this.confirmMethod && typeof this.confirmMethod === 'function') {
        this.confirmMethod()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import './common.less';

// 复用表单容器样式
.fail-content {
   .form-wrapper();
}

.icon-wrapper {
     .success-fail-icon-wrapper();
}


.main-title {
   .success-fail-main-title();
}

.hints {
   .success-fail-hints();
}
// 复用按钮样式
.confirm-btn {
   .success-fail-button();
}
</style>
